<template lang="pug">
div
  el-form(class="wrapper" label-width="200px" label-position="right" size="small")
    el-form-item(label="打印模板" prop="formType")
      div
        span(v-if="!designCompleted" style="margin-right: 10px;font-size: 14px;color: #606266;") 未设置打印表单
        el-button(v-else type="" size="mini" @click="handleDesignDown") 下载
        el-button( type="" size="mini" :disabled="isViewMode" @click="handleOnlineDesign") 在线设计
        el-upload(ref="upload" v-loading="loading" :http-request="httpRequest" class="upload-file" accept=".doc,.docx"
        :show-file-list="false" style="display: inline-block; margin: 0 10px" action="/" :disabled="isViewMode")
          el-button( type="" size="mini" :disabled="isViewMode" @click="beforeUpload") 本地上传
        el-button(v-if="designCompleted" type="danger" size="mini" :disabled="isViewMode" @click="handleDesignDel") 删除
        el-tooltip(placement="top" content="本地上传只能上传docx或doc格式的模板")
          i(class="el-tooltip el-icon-question" style="margin-left:2px;margin-right:5px") 上传格式说明
    el-form-item(v-if="designCompleted" label="" prop="formType")
      el-checkbox(v-model="basicForm.isPdfPrintTemplate" :disabled="isViewMode" :true-label="1" :false-label="0") 将成果输出为pdf（如果不勾选，将输出为docx格式的文件）
    el-form-item(v-if="designCompleted" label="" prop="formType")
      div 成果文件名
        el-input(v-model="basicForm.printTemplateName" class="inlineBlock" :readonly="true" size="mini")
        el-button(type="text" size="mini" :disabled="isViewMode" @click="handleGenerateName('printTemplateName')") 生成文件名
    el-form-item(v-if="designCompleted" label="" prop="formType")
      div 成果文件输出目录
        span(v-if="isRelatePrj" class="marginR10 marginL10") {{ basicForm.printTemplateFolderName}}
        el-button(v-if="isRelatePrj" type="text" size="mini" :disabled="isViewMode" @click="handleChooseFolder") +选择目录
        div(v-if="isRelatePrj")
          el-checkbox(v-model="basicForm.isNewDirectory" :disabled="isViewMode" :true-label="1" :false-label="0") 新建文件夹保存成果文件
        div(v-if="isRelatePrj && basicForm.isNewDirectory") 文件夹名称
          el-input(v-model="basicForm.newFolderName" class="inlineBlock" :readonly="true" size="mini")
          el-button(type="text" size="mini" :disabled="isViewMode" @click="handleGenerateName('newFolderName')") 生成文件夹名
        span(v-if="!isRelatePrj" class="marginL10") 当前流程未关联项目，不可选择成果文件输入目录！
        .tips
            i(class="el-tooltip el-icon-question" style="margin-left:2px;margin-right:5px") 注:如果未选择存放目录，流程结束后生成的文件将存放在隐藏目录下，可以在【我的创建】中下载相应的文件
    el-form-item(v-if="designCompleted" label="" prop="formType")
      div(class="flex2 flex")
        span(class="marginR10") 同名文件处理策略
        el-radio-group(v-model="basicForm.sameFilePolicy")
          el-radio(:label="0" :disabled="isViewMode") 覆盖（升级版本，默认）
          el-radio(:label="1" :disabled="isViewMode") 重命名（将在文件名中添加时间戳）
    el-form-item(v-if="designCompleted" label="" prop="formType")
      div(class="flex2 flex")
        span(class="marginR10") 流程结束后自动生成成果文件
        el-radio-group(v-model="basicForm.autoGenPrintFile")
          el-radio(:label="1" :disabled="isViewMode") 是
          el-radio(:label="0" :disabled="isViewMode") 否
  el-dialog(title="内容构造器" :visible.sync="showFileNameDlg" width="800px" :before-close="handleGenerateNameClose")
    el-form(class="wrapper" label-width="200px" label-position="top" size="small")
      el-form-item(label="原始内容")
        el-input(v-model="basicForm[curGenerateNameField]" :disabled="true")
      el-form-item(label="当前内容")
        el-input(v-model="currentContent" ref="inputWord" @blur="handleInputBlur")
        div
          el-button(type="text" size="mini" :disabled="isViewMode" @click="handleReset") 重置
        div
          el-button(type="" size="mini" @click="handleInput('flowName')") 流程名称
            el-tooltip(placement="top" content="当前流程的名称")
              i(class="el-tooltip el-icon-question" style="margin-left:2px;margin-right:5px")
          el-button(type="" size="mini" @click="handleInput('createUserName')") 发起人
            el-tooltip(placement="top" content="创建流程（或表单）的用户姓名")
              i(class="el-tooltip el-icon-question" style="margin-left:2px;margin-right:5px")
          el-button(type="" size="mini" @click="handleInput('currentTime')") 当前时间
            el-tooltip(placement="top" content="输出格式：yyyyMMddHHmmss")
              i(class="el-tooltip el-icon-question" style="margin-left:2px;margin-right:5px")
          el-button(type="" size="mini" @click="handleInput('currentDate')") 当前日期
            el-tooltip(placement="top" content="输出格式：yyyyMMdd")
              i(class="el-tooltip el-icon-question" style="margin-left:2px;margin-right:5px")
          el-button(type="" size="mini" @click="handleInput('seqNo')") 序号
            el-tooltip(placement="top" content="用户防止文件名重复，当出现重复名称时用它形成自增。1、2、.., 第一个文件，此字段是空值")
              i(class="el-tooltip el-icon-question" style="margin-left:2px;margin-right:5px")
    span(slot="footer" class="dialog-footer")
      el-button(type="" size="mini"  @click="handleGenerateNameClose") 取消
      el-button(type="primary" size="mini"  @click="handleConfirmChangeGenerateName") 确定
  el-dialog(title="选择目录" :visible.sync="showFolderDlg" width="800px" :before-close="handleFolderClose")
    div(slot="title" class="")
      span(class="size18") 选择目录
      el-select(class="dialog-title" v-model="folderTemplateTypeId" size="mini" placeholder="项目类型" @change="handlefolderTemplateTypeChanged")
        el-option(v-for="item in folderTemplateTypeList" :key="item.dicId" :label="item.cnName" :value="item.dicId")
    div(class="flex")
      el-input(size="small" placeholder="输入关键字进行过滤" v-model="filterText")
    el-tree(ref="tree" :data="treeData" show-checkbox node-key="folderId" default-expand-all
    :props="defaultProps" :check-strictly="true" @check-change="handleCheckChange")
    span(slot="footer" class="dialog-footer")
      el-button(type="" size="mini"  @click="handleFolderClose") 取消
      el-button(type="primary" size="mini"  @click="handleConfirmChooseFolderId") 确定
</template>

<script>
import EditMode from "@/CommonDP/enums/EditMode";
import { flowParams } from "../config";
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import docService from "@/CommonDP/service/doc-service";
import { windowOpen } from "@/CommonDP/utils/docPublic";
import { downloadDesignPrintFile, downloadFile } from "@/CommonDP/utils";
import folderTemplateService from "@/CommonDP/service/admin/folderTemplate-service";
import dicService from "@/CommonDP/service/dic-service";
export default {
  props: {
    viewMode: {
      type: Number,
      default: EditMode.CREATE_0
    }
  },
  data() {
    return {
      EditMode: EditMode,
      permForm: flowParams.permForm,
      basicForm: flowParams.basicForm,
      loading: false,
      showFileNameDlg: false,
      showFolderDlg: false,
      cursorIndex: "",
      currentContent: "",
      outputFolderId: "",
      directoryTree: [],
      defaultProps: {
        children: "childrenList",
        label: "folderName"
      },
      filterText: "",
      folderTemplateTypeList: [],
      folderTemplateTypeId: "",
      curGenerateNameField: ""
    };
  },
  computed: {
    designCompleted() {
      return !!this.basicForm.printTemplateFileId;
    },
    isViewMode() {
      return this.viewMode === EditMode.VIEW_2;
    },
    isCreated() {
      return this.viewMode === EditMode.CREATE_0;
    },
    isRelatePrj() {
      return this.basicForm.formType === 1;
    },

    treeData() {
      const { filterText, directoryTree } = this;
      const searchValue = filterText;
      if (searchValue) {
        const handleTreeData = this.handleTreeData(directoryTree, searchValue);
        return handleTreeData;
      }
      return directoryTree;
    }
  },

  mounted() {
    this.init();
  },

  beforeDestroy() {
    window.removeEventListener("deliveryFileId", this.deliveryFileId);
  },

  methods: {
    init() {
      window.addEventListener("deliveryFileId", this.deliveryFileId);
      this.outputFolderId = this.basicForm.printTemplateFolderId;
    },
    deliveryFileId(e) {
      const { detail } = e;
      this.basicForm.printTemplateFileId = detail;
      console.log(detail, e);
    },
    handleDesignDown() {
      const { printTemplateFileId, printTemplateFileVersion } = this.basicForm;
      const downzipurl = downloadDesignPrintFile(printTemplateFileId, printTemplateFileVersion);
      downloadFile(downzipurl);
    },
    beforeUpload(e) {
      if (!this.validate()) {
        e.stopPropagation();
      }
    },
    validate() {
      const { isDynamicForm } = this.basicForm;
      if (this.isCreated) {
        this.$warn("请先保存流程");
        return false;
      }
      if (isDynamicForm) {
        this.$warn("只能是在线表单的模式，才能关联打印模板");
        return false;
      }
      return true;
    },
    handleOnlineDesign() {
      if (this.validate()) {
        const { flowName, flowKey, printTemplateFileId } = this.basicForm;
        const { flowDefinitionId, currentVersionId } = flowParams;
        console.log(flowName, flowKey, flowDefinitionId, currentVersionId, flowParams);
        windowOpen({
          path: "/printDesignDoc",
          query: {
            prjId: this.prjId,
            enterpriseId: this.enterpriseId,
            flowName,
            flowDefinitionId,
            currentVersionId,
            flowKey,
            fileId: printTemplateFileId
          }
        });
      }
    },
    handleDesignDel() {
      this.$confirm("警告：如果删除模板，流程将不会再生成成果文件，确认继续吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const { flowDefinitionId } = flowParams;
        const { printTemplateFileId: fileId } = this.basicForm;
        mongeService
          .delDesignPrintFile(fileId, flowDefinitionId)
          .then((res) => {
            if (res.result === "0") {
              this.$message.success("删除成功");
              this.basicForm.printTemplateFileId = null;
              this.basicForm.printTemplateFileVersion = null;
            } else {
              this.$message.error("删除失败,请重新删除");
            }
          })
          .catch(() => {
            this.$message.error("删除失败,请重新删除");
          });
      });
    },
    async httpRequest({ file }) {
      try {
        this.loading = true;
        const data = new FormData();
        data.append("file", file);
        const { flowDefinitionId } = flowParams;
        const res = await mongeService.designPrintManualUpload(flowDefinitionId, data);
        const { fileId, fileVersion } = res.data;
        this.basicForm.printTemplateFileId = fileId;
        this.basicForm.printTemplateFileVersion = fileVersion;
        this.loading = false;
        this.$success("上传成功");
      } catch (error) {
        console.error(error);
        this.$message.error("上传失败");
        this.loading = false;
      }
    },
    async queryhiddenFolder() {
      const { data } = await docService.queryEnterpriseIdhiddenFolder(this.enterpriseId);
      return data || "";
    },
    handleGenerateName(field) {
      this.curGenerateNameField = field;
      this.handleReset();
      this.showFileNameDlg = true;
    },
    async handleChooseFolder() {
      this.showFolderDlg = true;
      if (!this.folderTemplateTypeList?.length) {
        await this.getModuleList();
      }
      if (this.outputFolderId) {
        this.$refs.tree.setCheckedKeys([this.outputFolderId], true);
      }
    },
    handleGenerateNameClose() {
      this.currentContent = "";
      this.showFileNameDlg = false;
    },
    handleFolderClose() {
      this.outputFolderId = this.basicForm.printTemplateFolderId;
      this.showFolderDlg = false;
    },
    handleReset() {
      this.currentContent = this.basicForm[this.curGenerateNameField] || "";
      this.cursorIndex = "";
    },
    handleInputBlur(e) {
      this.cursorIndex = e.srcElement.selectionStart;
    },
    handleInput(label) {
      // 获取el-input中的input元素
      const txt = this.currentContent;
      const cursorIndex = this.cursorIndex || 0;
      const start = txt.substring(0, cursorIndex);
      const end = txt.substring(cursorIndex, txt.length);

      // 插入关键词
      this.currentContent = start + `\${${label}}` + end;

      // 获取文本框，设置焦点，处理光标位置
      if (this.$refs.inputWord) {
        // this.$refs.inputWord.focus();
        this.$nextTick(() => {
          var a = this.$refs.inputWord.$el.firstElementChild;
          a.focus();
          a.selectionStart = cursorIndex + label.length + 3;
          a.selectionEnd = cursorIndex + label.length + 3;
        });
      }
    },
    handleConfirmChangeGenerateName() {
      this.basicForm[this.curGenerateNameField] = this.currentContent;
      this.$message.success("名称已更新");
      this.handleGenerateNameClose();
    },

    //  树形表格过滤
    handleTreeData(treeData, searchValue) {
      if (!treeData || treeData.length === 0) {
        return [];
      }
      const array = [];
      for (let i = 0; i < treeData.length; i += 1) {
        let match = false;
        for (const pro in treeData[i]) {
          if (pro === "folderName") {
            if (typeof treeData[i][pro] === "string") {
              match |= treeData[i][pro].includes(searchValue);
              if (match) break;
            }
          }
        }
        if (this.handleTreeData(treeData[i].childrenList, searchValue).length > 0 || match) {
          array.push({
            ...treeData[i],
            childrenList: this.handleTreeData(treeData[i].childrenList, searchValue)
          });
        }
      }
      return array;
    },
    async getModuleList() {
      const dictRes = await dicService.getDicList("folderTemplateType");
      this.folderTemplateTypeList = dictRes.data || [];
      if (this.folderTemplateTypeList.length) {
        this.folderTemplateTypeId = this.folderTemplateTypeList[0].dicId;
      }
      await this.queryTree();
    },
    async queryTree() {
      const { data } = await folderTemplateService.queryFolderTemplateTree(this.folderTemplateTypeId);
      this.directoryTree = data;
      this.filterText = "";
    },
    async handlefolderTemplateTypeChanged() {
      await this.$nextTick();
      await this.queryTree();
    },
    handleCheckChange(data, checked, tree) {
      console.log(data, checked, tree);
      if (checked) {
        this.outputFolderId = data.folderId;
        this.$refs.tree.setCheckedKeys([data.folderId], true);
      } else if (this.outputFolderId === data.folderId && !checked) {
        this.outputFolderId = "";
      }
    },

    handleConfirmChooseFolderId() {
      this.basicForm.printTemplateFolderId = this.outputFolderId;
      this.basicForm.printTemplateFolderName = this.getDirectoryName(this.outputFolderId);
      this.basicForm.printTemplateFolderTypeId = this.folderTemplateTypeId;
      this.handleFolderClose();
    },

    getParentIds(list, id) {
      const temp = []; // 结果对象
      const forFn = function (arr, id) {
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i];
          if (item.folderId === id) {
            forFn(list, item.parentId);
            temp.push(item);
            break;
          } else {
            if (item.childrenList) {
              forFn(item.childrenList, id);
            }
          }
        }
      };
      forFn(list, id);
      return temp;
    },
    getDirectoryName(key) {
      try {
        const parentNodes = this.getParentIds(this.directoryTree, key);
        console.log(parentNodes);
        return parentNodes.map((item) => item.folderName).join("/");
      } catch (error) {
        console.error(error);
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  max-width: 800px;
  margin: 0 auto;
  font-size: 14px;
}
.inlineBlock {
  display: inline-block;
  width: 400px;
  margin: 0 10px 0 15px;
}
.tips {
  color: #888;
  font-size: 0.8em;
}
.flex {
  display: flex;
  justify-content: flex-end;
}
.flex2 {
  justify-content: flex-start;
  align-items: center;
}
.dialog-title {
  margin-left: 10px;
  width: 200px;
  display: inline-block;
}
.size18 {
  font-size: 18px;
  color: #303133;
}
.marginR10 {
  margin-right: 10px;
}
.marginL10 {
  margin-left: 10px;
}
</style>
